module.exports = __webpack_public_path__ + "img/1.63785e3b.png";